import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useProfileCompletion } from "@/hooks/useProfileCompletion";

interface ProfileGuardProps {
  children: React.ReactNode;
}

const ProfileGuard = ({ children }: ProfileGuardProps) => {
  const { user } = useAuth();
  const { isProfileComplete, loading } = useProfileCompletion();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Si l'utilisateur est connecté et que son profil n'est pas complet
    // et qu'il n'est pas déjà sur la page /account, le rediriger
    if (user && !loading && isProfileComplete === false && location.pathname !== '/account') {
      navigate('/account', { replace: true });
    }
  }, [user, isProfileComplete, loading, location.pathname, navigate]);

  // Si on est en train de vérifier le profil, ne rien afficher
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Si l'utilisateur est connecté mais son profil n'est pas complet
  // et qu'il n'est pas sur /account, ne rien afficher (la redirection est en cours)
  if (user && isProfileComplete === false && location.pathname !== '/account') {
    return null;
  }

  return <>{children}</>;
};

export default ProfileGuard;
